import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-3 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "card mb-3 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_10 = { class: "form-group mb-0" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_13 = {
  key: 1,
  class: "text-info"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { class: "dropdown" }
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 5 }
const _hoisted_24 = { class: "card mb-3 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "custom-search" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-9" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "card mb-3 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_36 = { class: "form-group mb-0" }
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_39 = {
  key: 1,
  class: "text-info"
}
const _hoisted_40 = { key: 2 }
const _hoisted_41 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { class: "dropdown" }
const _hoisted_44 = { class: "dropdown-menu" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, [
          _cache[4] || (_cache[4] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.reception.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.getDate(_ctx.reception.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.reception.note_type), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-header pb-3" }, [
        _createElementVNode("h5", null, "Liste des Colis Ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control d-inline-block",
                      placeholder: "Chercher",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.searchTerm]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1,
          "search-options": {
          enabled: true,
          externalQuery: _ctx.searchTerm,
        },
          responsive: ""
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [6]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_12, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_13, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_14, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second).code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'price')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                      _cache[9] || (_cache[9] = _createTextVNode(" DH ", -1))
                    ], 64))
                  : (props.column.field === 'updated_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                    : (props.column.field === 'actions')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _cache[13] || (_cache[13] = _createElementVNode("button", {
                              class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false"
                            }, [
                              _createElementVNode("i", { class: "flaticon-dots" })
                            ], -1)),
                            _createElementVNode("ul", _hoisted_18, [
                              _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                  class: "dropdown-item d-flex align-items-center",
                                  onClick: ($event: any) => (_ctx.showDetailSuivi(props.row))
                                }, _cache[10] || (_cache[10] = [
                                  _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Historique ", -1)
                                ]), 8, _hoisted_19)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                  class: "dropdown-item d-flex align-items-center",
                                  onClick: ($event: any) => (_ctx.showDetails(props.row))
                                }, _cache[11] || (_cache[11] = [
                                  _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Infos ", -1)
                                ]), 8, _hoisted_20)
                              ]),
                              (
                        _ctx.auth.can('PARCELS') &&
                        (_ctx.user?.role_id === 1 || _ctx.user?.role_id === 2) &&
                        props.row.status !== 'NEW_PARCEL' &&
                        props.row.status !== 'WAITING_PICKUP' &&
                        props.row.status !== 'RETURNED' &&
                        props.row.status !== 'RETURNED_PARTIAL'
                      )
                                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.showUpdate(props.row))
                                    }, _cache[12] || (_cache[12] = [
                                      _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Modifier ", -1)
                                    ]), 8, _hoisted_22)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "search-options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header pb-3" }, [
        _createElementVNode("h5", null, "Scan code suivi")
      ], -1)),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.SearchColis && _ctx.SearchColis(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Code Suivi :", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control d-inline-block",
                    placeholder: "Code Suivi",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.codeColis) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.codeColis]
                  ])
                ])
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-md-3 d-flex align-items-end" }, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-success buttons",
                  style: {"margin-right":"12px"}
                }, [
                  _createElementVNode("i", { class: "ph ph-scan" })
                ])
              ], -1)),
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-12" }, [
                _createElementVNode("hr")
              ], -1))
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "card-header pb-3" }, [
        _createElementVNode("h5", null, "Liste des Colis Ramassés")
      ], -1)),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control d-inline-block",
                      placeholder: "Chercher",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm1) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.searchTerm1]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows2,
          "search-options": {
          enabled: true,
          externalQuery: _ctx.searchTerm1,
        },
          responsive: ""
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [19]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_38, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[20] || (_cache[20] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_39, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_40, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second).code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'updated_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                  : (props.column.field === 'actions')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _cache[26] || (_cache[26] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_44, [
                            _createElementVNode("li", null, [
                              _createElementVNode("button", {
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.showDetailSuivi(props.row.id))
                              }, _cache[22] || (_cache[22] = [
                                _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Historique ", -1)
                              ]), 8, _hoisted_45)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("button", {
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.showDetails(props.row))
                              }, _cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Infos ", -1)
                              ]), 8, _hoisted_46)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("button", {
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.showUpdate(props.row))
                              }, _cache[24] || (_cache[24] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Modifier ", -1)
                              ]), 8, _hoisted_47)
                            ]),
                            _cache[25] || (_cache[25] = _createElementVNode("li", null, [
                              _createElementVNode("button", {
                                class: "dropdown-item d-flex align-items-center text-danger",
                                title: "Supprimer Colis"
                              }, [
                                _createElementVNode("i", { class: "flaticon-trash lh-1 me-8 position-relative top-1" }),
                                _createTextVNode(" Supprimer ")
                              ])
                            ], -1))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "search-options"])
      ])
    ])
  ], 64))
}